'use client';

import type { ComponentType } from 'react';

import {
  NotLiveState,
  SuspendedState,
  UnreachableState,
} from '@/components/page-states';
import type { UnavailableBookingPageStatus } from '@/helpers/tenant';

const STATE_BY_STATUS: Record<UnavailableBookingPageStatus, ComponentType> = {
  'not-live': NotLiveState,
  suspended: SuspendedState,
  unreachable: UnreachableState,
};

// -mb-40 gives back the <main> bottom padding, so the block centres on the
// viewport rather than on the space above the padding.
export const BookingPageUnavailable = ({
  status,
}: {
  status: UnavailableBookingPageStatus;
}) => {
  const State = STATE_BY_STATUS[status];

  return (
    <div className="-mb-40 flex flex-1 items-center justify-center px-4 py-16">
      <State />
    </div>
  );
};
